import styled from "@emotion/styled";
export const HelpRoot = styled.div`
  padding: 2rem;
`;
export const HelpBody = styled.div`
  margin: 1rem 0;
`;
export const HelpLinks = styled.div`
  margin: 1rem 0;
  max-width: 29.25rem;
`;
export const InfoBlockRoot = styled.div`
  padding: 1rem;
`;
export const InfoBlockButton = styled.div`
  margin: 1rem;
`;
